<template>

<core-modal-setting title="Default" :value="valueText" placeholder="Not selected" :is-inline="true">
        
    <core-input-checklist 
        :options="options"
        v-model="internalValue"
    />

</core-modal-setting>

</template>

<script>

import mixSetting from 'core/mixin/modal/Setting'

export default {

    mixins: [mixSetting],

    computed: {

        options: function() {

            var options = []

			var context = 0

			if (this.$currentViewContext === 'collection') context = 1
			if (this.$currentViewContext === 'ratings') context = 2
			if (this.$currentViewContext === 'plays') context = 3
			if (this.$currentViewContext === 'gameplays') context = 4

			var items = this.$_.sortBy(this.$store.getters['data/views/list'], function(item) {

				return item.name.toLowerCase()

			})

			items = this.$_.filter(items, function(item) {

				return item.context === context

			})

            this.$_.each(items, function(item) {

                options.push({
                    text: item.name,
                    value: item.id
                })

            })

            options.push({
                text: 'Standard List',
                value: 'list'
            })

            options.push({
                text: 'Standard Sheet',
                value: 'sheet'
            })

            options.push({
                text: 'Standard Cards',
                value: 'grid'
            })

            options.push({
                text: 'Standard Gallery',
                value: 'gallery'
            })

            return options

        }

    }

}

</script>

<style scoped>

</style>